import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { addModal, removeModal } from '@state-mgmt/slices/appSlice';

import ExportConfirmModal from '@components/ExportConfirmModal/ExportConfirmModal';

export const useExportLocalDataModal = () => {
  const modalKey = 'export-local-data-modal';
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(removeModal({ key: modalKey }));
  }, [dispatch]);

  const displayModal = useCallback(
    (exportData: () => void) => {
      const children = (
        <ExportConfirmModal
          onConfirm={() => {
            exportData();
            onClose();
          }}
          onClose={onClose}
        />
      );
      dispatch(addModal({ key: modalKey, props: { visible: true, children, onClose } }));
    },
    [dispatch, onClose]
  );

  return { displayModal };
};
